import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import Button from '../components/atoms/Button';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import useIsBackoffice from '../hooks/useIsBackoffice';
import { clearReservation } from '../store/slices/orders';
import { OrderTimeout } from '../components/icons';

const TimeoutPage = () => {
  const dispatch = useDispatch();
  const isBackoffice = useIsBackoffice();
  const { event } = useGetSelectedEvent({ slug: !isBackoffice });
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(clearReservation());
  }, [dispatch]);

  return (
    <div className="flex flex-col gap-6 lg:my-6 justify-center items-center glass-surface">
      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex items-center justify-center p-4">
          <OrderTimeout className="w-auto h-auto max-w-[140px] object-contain" />
        </div>
        <div className="flex flex-col gap-4 p-2 justify-center flex-start text-center md:text-left">
          <h1 className="text-lg font-medium">
            ¡Se acabó el tiempo para comprar!
          </h1>
          <div>
            <p className="text-sm text-text-tertiary">
              Las entradas seleccionadas se pusieron nuevamente en venta. Si todavía
              estas interesado en comprar, por favor inciá el proceso nuevamente.
            </p>
          </div>
        </div>
      </div>
      <div className="flex md:justify-start justify-center mt-2">
        <Button onClick={() => navigate(isBackoffice ? `/admin/${event?.business_id}/events/${event?.id}` : `/events/${event?.slug}`)}>
          Volver a la página del evento
        </Button>
      </div>
    </div>
  );
};

export default TimeoutPage;
